import React, { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { getProductDetails, getTrendingProducts, favouriteUnfavouriteProduct } from "../../services/product.services";
import ShoplistSelectModal from "../../components/ShoplistSelectModal";
import { globalsearchData } from "../../services/stream.service";
import { createLeads } from "../../services/stream.service";
import { sendWhatsappMessage, sendSellerNotification, openWhatsappChat } from "../../services/message.service";
import { ROLE } from "../../../../utils/Constants";
import { getUser, isGuest, getSellerProfileUrl, isUserLoggedIn, showLoginRequiredModal } from "../../../../utils/commonfunction";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import AvatarImage from "../../components/AvatarImage";
import ShareModal from "../../components/ShareModal";
import { Share2 } from "lucide-react";
import { getColorPalettes } from "../../services/stream.service";
import { getColorDotStyle } from "../../../admin/common/colorPalettePicker";
import { useSelector } from "react-redux";
import ProductImageZoomer from "../../components/ProductImageZoomer";

const isVideoMedia = (item) => {
  if (!item) return false;
  if (typeof item === "string") {
    return /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(item);
  }
  if (item.type === "video" || item.isVideo) return true;
  if (item.url && /\.(mp4|webm|mov|avi|mkv|m4v|ogv)(\?.*)?$/i.test(item.url)) return true;
  return false;
};

const getCompressedImageUrl = (img) => {
  if (!img) return "";
  if (typeof img === "object") {
    if (img.compressed_url) return img.compressed_url;
    if (img.compressed) {
      if (typeof img.compressed === "string" && img.compressed.startsWith("http")) return img.compressed;
      return img.compressed;
    }
    if (img.compressed_image) return img.compressed_image;
    if (img.url) return getCompressedImageUrl(img.url);
    return "";
  }
  if (typeof img === "string") {
    if (img.includes("compressed_")) return img;
    const lastSlash = img.lastIndexOf("/");
    if (lastSlash !== -1) {
      const dir = img.substring(0, lastSlash + 1);
      const filename = img.substring(lastSlash + 1);
      const dot = filename.lastIndexOf(".");
      const nameWithoutExt = dot !== -1 ? filename.substring(0, dot) : filename;
      return `${dir}compressed_${nameWithoutExt}.webp`;
    }
    return img;
  }
  return "";
};

const getAttributeLabel = (key, t) => {
  const normalized = String(key || "").toLowerCase().trim();
  let labelKey = normalized.replace(/\s+/g, "_");
  if (normalized.includes("color") || normalized.includes("colour")) {
    labelKey = "colors";
  }
  return t(`product_details.attribute_labels.${labelKey}`, { defaultValue: key });
};

function Details() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const o_id = searchParams.get("o_id");
  const userData = getUser(ROLE.USER) || {};
  const userID = userData?._id;
  const users = getUser(ROLE.USER);
  const phone_number = users?.phone_number?.replace(/\D/g, "");

  const [product, setProduct] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [productsList, setProductsList] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const [isShoplistModalOpen, setIsShoplistModalOpen] = useState(false);
  const sliderRef = useRef(null);

  const handleColorClick = (colorName) => {
    if (!product || !product.images || !colorName) return;
    const index = product.images.findIndex(img => {
      if (!img.color) return false;
      return img.color.toLowerCase().trim() === colorName.toLowerCase().trim();
    });
    if (index !== -1) {
      setActiveImageIndex(index);
    }
  };

  const handlePrevImage = () => {
    if (!product || !product.images || product.images.length <= 1) return;
    setActiveImageIndex(prev => (prev === 0 ? product.images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    if (!product || !product.images || product.images.length <= 1) return;
    setActiveImageIndex(prev => (prev === product.images.length - 1 ? 0 : prev + 1));
  };

  const [colorPalettes, setColorPalettes] = useState([]);
  const [globalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);
  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [o_id]);

  useEffect(() => {
    getColorPalettes().then(resp => {
      if (resp?.success && Array.isArray(resp.data)) {
        setColorPalettes(resp.data);
      }
    }).catch(console.error);
  }, []);

  console.log(product, "product");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  console.log(phone_number, "csd12121212");

  const handleToggleFavouriteProduct = async () => {
    const isLoggedIn = Boolean(
      users && 
      (users._id || users.id || users.token) && 
      !isGuest()
    );

    if (!isLoggedIn) {
      Swal.fire({
        icon: "warning",
        title: t("common.login_required"),
        text: t("common.login_required_to_favorite", { defaultValue: "Please login to add to favourites" }),
        showCancelButton: true,
        confirmButtonColor: "var(--primary-400, #ff4081)",
        cancelButtonColor: "#71717a",
        confirmButtonText: t("link_login"),
        cancelButtonText: t("product_details.close"),
      }).then((result) => {
        if (result.isConfirmed) {
          const currentPath = window.location.pathname + window.location.search;
          navigate(`/user/login?redirect=${encodeURIComponent(currentPath)}`);
        }
      });
      return;
    }

    setIsShoplistModalOpen(true);
  };

  const handleShoplistSaved = (savedShoplistIds) => {
    const isFav = Array.isArray(savedShoplistIds) && savedShoplistIds.length > 0;
    setProduct((prev) => ({
      ...prev,
      isFavourite: isFav,
      isFavouriteProduct: isFav,
    }));
  };

  useEffect(() => {
    const fetchProductDetails = async () => {
      if (!o_id) {
        setError(t("product_details.id_not_found"));
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await getProductDetails(o_id);

        if (response.success) {
          setProduct(response.data);
          setError(null);
        } else {
          setError(response.message || t("product_details.fetch_failed"));
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
        setError(err.message || t("common.something_went_wrong"));
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [o_id]);

  useEffect(() => {
    const colorParam = searchParams.get("color");
    if (colorParam && product?.images && Array.isArray(product.images) && product.images.length > 0) {
      const normalizedParam = colorParam.trim().toLowerCase();
      const idx = product.images.findIndex((img) => {
        if (!img) return false;
        const imgColor = typeof img.color === "string"
          ? img.color.trim().toLowerCase()
          : (img.color?.name ? String(img.color.name).trim().toLowerCase() : "");
        return imgColor && (imgColor === normalizedParam || imgColor.includes(normalizedParam) || normalizedParam.includes(imgColor));
      });
      if (idx !== -1) {
        setActiveImageIndex(idx);
      }
    }
  }, [searchParams, product]);

  useEffect(() => {
    const fetchRelatedProducts = async () => {
      try {
        const res = await globalsearchData({ limit: 50 });
        if (res?.data?.products && res.data.products.length > 0) {
          setProductsList(res.data.products);
        } else {
          const resTrending = await getTrendingProducts();
          if (resTrending?.data && Array.isArray(resTrending.data)) {
            setProductsList(resTrending.data);
          }
        }
      } catch (err) {
        console.error("Error fetching related products:", err);
      }
    };

    fetchRelatedProducts();
  }, []);

  useEffect(() => {
    if (!product) return;
    const title = product?.title || "Thela Live Product";
    const desc = product?.description || "Check out this product on Thelalive!";
    const rawImg = product?.image || (product?.images && (typeof product.images[0] === 'string' ? product.images[0] : product.images[0]?.url)) || "/images/card1.png";
    const fullImg = rawImg.startsWith("http") ? rawImg : `${window.location.origin}${rawImg.startsWith("/") ? "" : "/"}${rawImg}`;
    const currentUrl = window.location.href;

    const setMetaTag = (attr, val, content) => {
      let el = document.querySelector(`meta[${attr}="${val}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, val);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    document.title = `${title} | Thela Live`;
    setMetaTag("property", "og:title", title);
    setMetaTag("property", "og:description", desc);
    setMetaTag("property", "og:image", fullImg);
    setMetaTag("property", "og:url", currentUrl);
    setMetaTag("property", "og:type", "product");
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", title);
    setMetaTag("name", "twitter:description", desc);
    setMetaTag("name", "twitter:image", fullImg);
  }, [product]);

  const currentIndex = productsList.findIndex(
    (p) => (p._id || p.product_id) === o_id
  );

  const prevProduct =
    productsList.length > 1 && currentIndex !== -1
      ? productsList[(currentIndex - 1 + productsList.length) % productsList.length]
      : productsList.length > 1
      ? productsList[0]
      : null;

  const nextProduct =
    productsList.length > 1 && currentIndex !== -1
      ? productsList[(currentIndex + 1) % productsList.length]
      : productsList.length > 1
      ? productsList[1] || productsList[0]
      : null;

  const scrollSliderLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollSliderRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const handleOpenMessageModal = () => {
    const user = getUser(ROLE.USER);
    const isLoggedIn = Boolean(
      user && 
      (user._id || user.id || user.token) && 
      !isGuest()
    );

    if (!isLoggedIn) {
      Swal.fire({
        icon: "warning",
        title: t("common.login_required"),
        text: t("common.login_required_to_send_msg"),
        showCancelButton: true,
        confirmButtonColor: "var(--primary-400, #ff4081)",
        cancelButtonColor: "#71717a",
        confirmButtonText: t("link_login"),
        cancelButtonText: t("product_details.close"),
      }).then((result) => {
        if (result.isConfirmed) {
          const currentPath = window.location.pathname + window.location.search;
          navigate(`/user/login?redirect=${encodeURIComponent(currentPath)}`);
        }
      });
      return;
    }

    const modal = document.getElementById("message_on_whatsapp");
    if (modal) {
      modal.showModal();
    }
  };

  const handleSendMessage = async () => {
    const user = getUser(ROLE.USER);
    const modal = document.getElementById("message_on_whatsapp");
    console.log("Current User:", user);

    const isLoggedIn = Boolean(
      user && 
      (user._id || user.id || user.token) && 
      !isGuest()
    );

    if (!isLoggedIn) {
      if (modal) modal.close();
      Swal.fire({
        icon: "warning",
        title: t("common.login_required"),
        text: t("common.login_required_to_send_msg"),
        showCancelButton: true,
        confirmButtonColor: "var(--primary-400, #ff4081)",
        cancelButtonColor: "#71717a",
        confirmButtonText: t("link_login"),
        cancelButtonText: t("product_details.close"),
      }).then((result) => {
        if (result.isConfirmed) {
          const currentPath = window.location.pathname + window.location.search;
          navigate(`/user/login?redirect=${encodeURIComponent(currentPath)}`);
        }
      });
      return;
    }

    const activePhoneNumber = (user?.phone_number || user?.phone || phone_number)?.replace(/\D/g, "");
    if (!activePhoneNumber) {
      if (modal) modal.close();
      Swal.fire({
        icon: "error",
        text: t("common.phone_required"),
      });
      return;
    }
    if (!message.trim()) {
      Swal.fire({
        icon: "error",
        text: t("common.message_required"),
      });
      return;
    }

    // Check if seller has phone number (use KYC number as priority)
    const seller_phone =
      product?.seller?.kyc_mobile_number ||
      product?.seller?.kyc_number ||
      product?.seller_kyc_number ||
      product?.kyc_mobile_number ||
      product?.seller_phone_number ||
      product?.seller?.phone_number;
    if (!seller_phone) {
      Swal.fire({
        icon: "warning",
        text: t("product_details.seller_phone_missing"),
      });
    }

    try {
      setSending(true);

      // 🎯 Create a lead before sending WhatsApp message
      try {
        const leadPayload = {
          product_id: o_id,
          stream_id: product?.stream_id,
          seller_id: product?.seller_id,
          buyer_id: userID,
        };
        const leadResponse = await createLeads(leadPayload);
        console.log("Lead Creation Response:", leadResponse);
      } catch (leadErr) {
        console.error("Lead creation failed:", leadErr);
      }

      // 📱 Step 1: Send message to CUSTOMER (existing flow)
      // const payload = {
      //   o_id,
      //   phone_number: phone_number,
      //   quantity,
      //   message,
      //   image: product?.image
      // };
      // console.log("Sending WhatsApp payload to customer:", payload);
      // const response = await sendWhatsappMessage(payload);
      
      // let customerMessageSent = false;
      // if (response.success) {
      //   customerMessageSent = true;
      //   console.log("✅ Message sent to customer successfully");
      // } else {
      //   console.error("❌ Failed to send message to customer:", response.message);
      //   Swal.fire({
      //     icon: "error",
      //     text: response.message || t("product_details.send_failed"),
      //   });
      //   setSending(false);
      //   return;
      // }

      // 📢 Step 2: Send notification to SELLER (new flow)
      if (seller_phone) {
 const notificationPayload = {
          seller_phone_number: seller_phone, // Sending to dynamic seller phone
          product_id: o_id,
          buyer_name: user?.name || user?.username || users?.name || users?.username || "Guest",
          buyer_phone: activePhoneNumber,
          quantity: quantity,
          message: message,
          image: product?.image // The API will handle sending the image
        };
        
        // This makes the API call to your backend
        sendSellerNotification(notificationPayload).catch(err => console.error("API send failed", err));
      
        // 🎯 ALWAYS OPEN WHATSAPP CHAT FOR SELLER (key behavior)
        // This happens regardless of API success/failure
        setTimeout(() => {
          try {
            // Build a clean, professional message with product details
            const imageLink =  "https://fastly.picsum.photos/id/481/200/200.jpg?hmac=aHV2Sqt0kxr96SHgdwdUuP4mu3m_EuPdtnslgUnkd1Y";
            const productLink = `${window.location.origin}/product-details?o_id=${o_id}`;
            
//   // ... inside handleSendMessage
// const imageLink = product?.image || ""; 
// const productLink = `${window.location.origin}/product-details?o_id=${o_id}`;

const sellerChatMessage = [
  // 1. RAW URL AT TOP (Triggers the big preview box)
  imageLink, 

  // 2. FORMATED HEADER
  `\n*${t("home.whatsapp_inquiry_header")}*`,

  // 3. PRODUCT DETAILS
  `\n${t("home.whatsapp_interested_in")} *${product?.title || t("common.fallback_product_title")}*`,
  `${t("home.whatsapp_quantity")}: *${quantity}*`,

  // 4. CUSTOMER MESSAGE
  message ? `\n"${message}"` : null,

  // 5. PRICE & CONTACT
  `\n${t("home.whatsapp_product_price")}: ${product?.isAskForPrice ? t("ask_to_seller") : product?.price ? `INR ${product.price}` : t("product_details.contact_for_price")}`,
  `\n${t("home.whatsapp_customer_contact")}: *${user?.name || user?.username || t("common.guest_user")}*`,
  `${t("home.whatsapp_whatsapp")}: ${activePhoneNumber}`,

  // 6. VIEW LINK
  `\n${t("home.whatsapp_view_full_details")}: \n${productLink}`,
]
.filter(Boolean)
.join("\n");


            console.log("Opening WhatsApp chat for seller...", seller_phone);
            const opened = openWhatsappChat(seller_phone, sellerChatMessage);
            if (opened) {
              console.log("✅ WhatsApp chat window opened for seller");
            } else {
              console.warn("⚠️ Could not open WhatsApp chat");
            }
          } catch (err) {
            console.error("Error opening WhatsApp chat:", err);
          }
        }, 500);
      }

      // 🎉 Show success message
      Swal.fire({
        icon: "success",
        text: seller_phone ? t("common.message_sent_to_you_opening_whatsapp") : t("common.message_sent_success"),
        timer: 3000,
      });
      
      setMessage("");
      setQuantity(1);
      setTimeout(() => {
        const modalEl = document.getElementById("message_on_whatsapp");
        if (modalEl) modalEl.close();
      }, 500);
    } catch (err) {
      console.error("Error sending message:", err);
      Swal.fire({
        icon: "error",
        text: err.message || "Something went wrong",
      });
    } finally {
      setSending(false);
    }
  };
  const truncateText = (text, maxLength) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };
  if (loading) {
    return (
      <div className="product-details py-10">
        <div className="container">
          <div className="text-center py-20 flex flex-col items-center gap-4">
            <div className="loading loading-spinner loading-lg text-[var(--primary-400)]"></div>
            <p className="body-lg text-zinc-500">{t("product_details.loading")}</p>
          </div>
        </div>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="product-details py-10">
        <div className="container">
          <div className="max-w-md mx-auto text-center py-20 px-6 border border-dashed border-zinc-200 rounded-3xl">
            <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
              </svg>
            </div>
            <p className="headings-h3 text-zinc-950 mb-2">{error || t("product_details.not_found")}</p>
            <p className="body-md text-zinc-500 mb-6">{t("product_details.error_subtitle")}</p>
            <button onClick={() => {
              if (window.history.state && window.history.state.idx > 0) {
                navigate(-1);
              } else {
                navigate("/user/products");
              }
            }} className="btn btn-outline">{t("btn_back")}</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="product-details py-8 lg:py-16">
        <div className="container">
          {/* Top Bar for Next / Prev Product Navigation */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6 pb-4 border-b border-zinc-100">
            {/* Left group: Back & Mobile Share */}
            <div className="flex items-center justify-between sm:justify-start gap-2 w-full sm:w-auto">
              <button
                type="button"
                onClick={() => {
                  if (window.history.state && window.history.state.idx > 0) {
                    navigate(-1);
                  } else {
                    navigate("/user/products");
                  }
                }}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl border border-zinc-200 text-zinc-600 hover:bg-zinc-50 hover:text-zinc-950 text-xs font-semibold transition-all shadow-2xs"
              >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-3.5 h-3.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>
                {t("btn_back") || "Back"}
              </button>

              {/* Share Button (Mobile row 1) */}
              <button
                type="button"
                onClick={() => setShowShareModal(true)}
                className="inline-flex sm:hidden items-center gap-1.5 px-3 py-1.5 rounded-xl border border-zinc-200 hover:border-[var(--secondary-500)] text-zinc-700 hover:text-[var(--secondary-500)] bg-white text-xs font-semibold shadow-2xs transition-all active:scale-95"
                title="Share Product"
              >
                <Share2 className="w-3.5 h-3.5 text-[var(--secondary-500)]" />
                <span>Share</span>
              </button>
            </div>

            {/* Right group: Prev/Next product and Desktop Share */}
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <button
                type="button"
                onClick={() => setShowShareModal(true)}
                className="hidden sm:inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl border border-zinc-200 hover:border-[var(--secondary-500)] hover:text-[var(--secondary-500)] text-xs font-semibold text-zinc-700 bg-white shadow-2xs transition-all active:scale-95 group shrink-0"
                title="Share Product"
              >
                <Share2 className="w-3.5 h-3.5 text-[var(--secondary-500)] group-hover:scale-110 transition-transform" />
                <span>Share</span>
              </button>

              {prevProduct && (
                <button
                  type="button"
                  onClick={() => navigate(`/user/product-details?o_id=${prevProduct._id || prevProduct.product_id}`, { replace: true })}
                  className="flex-1 sm:flex-initial inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl bg-zinc-100 hover:bg-zinc-200 text-xs font-semibold text-zinc-800 transition-all shadow-2xs group min-w-0"
                  title={prevProduct.title}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5 shrink-0 group-hover:-translate-x-0.5 transition-transform">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                  </svg>
                  <span className="hidden md:inline shrink-0">Prev:</span>
                  <span className="font-bold truncate max-w-[110px] sm:max-w-[140px]">{prevProduct.title}</span>
                </button>
              )}

              {nextProduct && (
                <button
                  type="button"
                  onClick={() => navigate(`/user/product-details?o_id=${nextProduct._id || nextProduct.product_id}`, { replace: true })}
                  className="flex-1 sm:flex-initial inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl bg-[var(--primary-400)] hover:opacity-90 text-white text-xs font-semibold transition-all shadow-2xs group min-w-0"
                  title={nextProduct.title}
                >
                  <span className="hidden md:inline shrink-0">Next:</span>
                  <span className="font-bold truncate max-w-[110px] sm:max-w-[140px]">{nextProduct.title}</span>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-3.5 h-3.5 shrink-0 group-hover:translate-x-0.5 transition-transform">
                    <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                  </svg>
                </button>
              )}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            {/* Left: Product Image & Slider */}
            <div className="product-image-container lg:sticky lg:top-24">
              <ProductImageZoomer
                images={product?.images && product.images.length > 0 ? product.images : [{ url: product?.image || "/images/banner5.png" }]}
                fallbackImage={product?.image || "/images/banner5.png"}
                activeImageIndex={activeImageIndex}
                setActiveImageIndex={setActiveImageIndex}
                productTitle={product?.title || t("product_details.fallback_title")}
                isFavourite={Boolean(product?.isFavourite || product?.isFavouriteProduct)}
                onToggleFavourite={handleToggleFavouriteProduct}
                colorPalettes={colorPalettes}
                onPrevImage={handlePrevImage}
                onNextImage={handleNextImage}
              />
            </div>

            {/* Right: Product Content */}
            <div className="product-info-container flex flex-col gap-6">
              <div className="product-header flex flex-col gap-3">
                <div className="flex flex-col gap-1">
                  {product.category?.title && (
                    <span className="headings-h6 text-primary-400 uppercase tracking-widest">
                      {product.category.title}
                    </span>
                  )}
                  <h1 className="headings-h1 text-zinc-950">
                    {product.title || t("product_details.fallback_title")}
                  </h1>
                </div>
                {/* Store & Seller Details Section */}
                {(() => {
                  const storeName = product.store_name || product.seller?.store_name || product.seller_store_name || product.seller_name || product.brand || "Store";
                  const storeAddress = product.store_address || product.seller_store_address || product.seller?.store_address || product.seller?.store_location?.store_address;
                  const storeImage = product.store_image || product.seller_store_image || product.seller?.store_image;
                  const sellerName = product.seller_name || product.seller?.name;

                  return (
                    <div className="bg-zinc-50 border border-zinc-200/80 rounded-2xl p-4 flex flex-col gap-3">
                      <div className="flex items-center justify-between gap-3">
                        <div className="flex items-center gap-3">
                          <AvatarImage
                            src={storeImage}
                            name={storeName || sellerName}
                            alt={storeName}
                            className="w-12 h-12 rounded-full object-cover border border-zinc-200 shadow-sm shrink-0"
                            style={{ fontSize: "20px" }}
                          />
                          <div>
                            <h4 className="headings-h5 text-zinc-950 font-semibold leading-snug">
                              {storeName}
                            </h4>
                            {sellerName && sellerName !== storeName && (
                              <p className="text-xs text-zinc-500 font-medium">
                                By {sellerName}
                              </p>
                            )}
                          </div>
                        </div>

                        {(product.seller_id || product.seller?._id) && (
                          <button
                            type="button"
                            onClick={() => {
                              const sellerObj = product.seller || {
                                _id: product.seller_id,
                                store_name: product.store_name,
                                name: product.seller_name,
                                business_handle: product.business_handle
                              };
                              navigate(getSellerProfileUrl(sellerObj));
                            }}
                            className="px-3 py-1.5 rounded-lg bg-white border border-zinc-200 text-xs font-semibold text-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 transition-all shadow-sm shrink-0"
                          >
                            Visit Store
                          </button>
                        )}
                      </div>

                      {storeAddress && (
                        <div className="flex items-start gap-2 text-zinc-600 text-xs font-medium pt-2 border-t border-zinc-200/60">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.75} stroke="currentColor" className="w-4 h-4 text-red-500 shrink-0 mt-0.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                          </svg>
                          <span className="leading-tight">{storeAddress}</span>
                        </div>
                      )}
                    </div>
                  );
                })()}
              </div>

              <div className="h-[1px] w-full bg-zinc-100" />

              <div className="price-section flex flex-col gap-1">
                <span className="headings-h6 text-zinc-400 uppercase tracking-wider">{t("product_details.price_label")}</span>
                <div className="flex items-baseline gap-2">
                  <span className="headings-h2 text-zinc-950">
                    {product.isAskForPrice || product.price == null || product.price === ""
                      ? t("ask_to_seller")
                      : `INR ${product.price}`}
                  </span>
                </div>
              </div>
              
              <div className="description-section flex flex-col gap-2">
                <span className="headings-h6 text-zinc-400 uppercase tracking-wider">{t("products.description")}</span>
                <p className="body-sm text-zinc-600 leading-relaxed">
                  {product.description || t("product_details.description_placeholder")}
                </p>
              </div>

              {product.attributes && Object.keys(product.attributes).length > 0 && (
                <div className="attributes-section flex flex-col gap-4">
                  {Object.entries(product.attributes).map(([key, value]) => {
                    const isColor = key.toLowerCase().includes('color') || key.toLowerCase().includes('colour');
                    return (
                    <div key={key} className="flex flex-col gap-1.5">
                      <span className="text-xs font-bold text-zinc-400 uppercase tracking-wider">{getAttributeLabel(key, t)}</span>
                      <div className="flex flex-wrap gap-2">
                        {Array.isArray(value) ? (
                          value.map((v, i) => {
                            const valName = typeof v === 'object' && v !== null ? v.name : v;
                            const dotStyle = getColorDotStyle(v, colorPalettes);
                            return (
                            <span 
                              key={i} 
                              onClick={() => isColor && handleColorClick(valName)}
                              className={`text-[11px] px-3 py-1 bg-zinc-50 text-zinc-700 rounded-md border border-zinc-200 font-medium flex items-center gap-1.5 ${isColor ? "cursor-pointer hover:border-zinc-400 hover:bg-zinc-100 transition-all" : ""}`}
                            >
                              {isColor && (
                                <span 
                                  className="w-2.5 h-2.5 rounded-full inline-block shrink-0" 
                                  style={dotStyle}
                                />
                              )}
                              {valName}
                            </span>
                          )})
                        ) : (
                          (() => {
                            const valName = typeof value === 'object' && value !== null ? value.name : value;
                            const dotStyle = getColorDotStyle(value, colorPalettes);
                            return (
                          <span 
                            onClick={() => isColor && handleColorClick(valName)}
                            className={`text-[11px] px-3 py-1 bg-zinc-50 text-zinc-700 rounded-md border border-zinc-200 font-medium flex items-center gap-1.5 ${isColor ? "cursor-pointer hover:border-zinc-400 hover:bg-zinc-100 transition-all" : ""}`}
                          >
                            {isColor && (
                              <span 
                                className="w-2.5 h-2.5 rounded-full inline-block shrink-0" 
                                style={dotStyle}
                              />
                            )}
                            {valName}
                          </span>
                          )})()
                        )}
                      </div>
                    </div>
                  )})}
                </div>
              )}

              <div className="action-buttons pt-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                {String(globalData?.show_whatsapp_button_product_details) === "true" && (
                  <button
                    className="btn btn-pri flex-1 !h-[50px] !min-h-[50px] !rounded-xl !p-0 overflow-hidden"
                    onClick={handleOpenMessageModal}
                  >
                    <div className="flex items-center justify-center gap-2 h-full w-full px-5">
                      <img src="/images/whatsapp.svg" alt="whatsapp" className="w-5 h-5 brightness-0 invert shrink-0" />
                      <span className="font-bold whitespace-nowrap text-sm">{t("product_details.whatsapp_btn")}</span>
                    </div>
                  </button>
                )}

                {/* <button
                  type="button"
                  onClick={handleToggleFavouriteProduct}
                  className={`btn font-bold !h-[50px] !min-h-[50px] !rounded-xl !p-0 shadow-sm transition-all active:scale-95 flex-1 sm:flex-initial border cursor-pointer ${
                    (product?.isFavourite || product?.isFavouriteProduct)
                      ? "bg-pink-50 text-pink-600 border-pink-200 hover:bg-pink-100"
                      : "bg-white hover:bg-zinc-50 border-zinc-300 text-zinc-800"
                  }`}
                >
                  <div className="flex items-center justify-center gap-2 h-full w-full px-5">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill={(product?.isFavourite || product?.isFavouriteProduct) ? "currentColor" : "none"}
                      stroke="currentColor"
                      strokeWidth={(product?.isFavourite || product?.isFavouriteProduct) ? "0" : "1.75"}
                      className={`w-5 h-5 ${(product?.isFavourite || product?.isFavouriteProduct) ? "text-pink-500" : "text-zinc-600"}`}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
                      />
                    </svg>
                    <span className="font-bold whitespace-nowrap text-sm">
                      {(product?.isFavourite || product?.isFavouriteProduct) ? "Favourited" : "Add to Favourites"}
                    </span>
                  </div>
                </button> */}

                <button
                  type="button"
                  onClick={() => setShowShareModal(true)}
                  className="btn bg-white hover:bg-zinc-50 border border-zinc-300 hover:border-[var(--secondary-500)] text-zinc-800 font-bold !h-[50px] !min-h-[50px] !rounded-xl !p-0 shadow-sm transition-all active:scale-95 flex-1 sm:flex-initial"
                >
                  <div className="flex items-center justify-center gap-2 h-full w-full px-6">
                    <Share2 className="w-4 h-4 text-[var(--secondary-500)] shrink-0" />
                    <span className="font-bold whitespace-nowrap text-sm">Share Product</span>
                  </div>
                </button>
              </div>
            </div>
          </div>

          {/* More Products Slider / Carousel */}
          {productsList && productsList.length > 0 && (
            <div className="mt-16 pt-10 border-t border-zinc-100">
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h3 className="headings-h3 text-zinc-950">{t("product_details.more_products")}</h3>
                  <p className="body-sm text-zinc-500">{t("product_details.more_products_hint")}</p>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={scrollSliderLeft}
                    className="w-10 h-10 rounded-full border border-zinc-200 flex items-center justify-center hover:bg-zinc-100 text-zinc-700 transition-colors shadow-sm"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                  </button>
                  <button
                    type="button"
                    onClick={scrollSliderRight}
                    className="w-10 h-10 rounded-full border border-zinc-200 flex items-center justify-center hover:bg-zinc-100 text-zinc-700 transition-colors shadow-sm"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                    </svg>
                  </button>
                </div>
              </div>

              <div
                ref={sliderRef}
                className="flex gap-5 overflow-x-auto scrollbar-none scroll-smooth py-2 px-1"
              >
                {productsList.map((item, idx) => {
                  const itemId = item._id || item.product_id;
                  const isCurrent = itemId === o_id;
                  const itemImg = item.image || (item.images && item.images[0]?.url) || "/images/banner5.png";
                  return (
                    <div
                      key={itemId || idx}
                      onClick={() => {
                        const targetUrl = `/user/product-details?o_id=${itemId}`;
                        if (!isUserLoggedIn()) {
                          showLoginRequiredModal({
                            navigate,
                            redirectUrl: targetUrl,
                          });
                          return;
                        }
                        navigate(targetUrl, { replace: true });
                      }}
                      className={`min-w-[210px] max-w-[220px] shrink-0 cursor-pointer group rounded-2xl p-3 border transition-all duration-300 ${
                        isCurrent
                          ? "border-[var(--primary-400)] bg-[var(--primary-50)]/20 ring-2 ring-[var(--primary-400)]/30 shadow-md"
                          : "border-zinc-200 hover:border-zinc-300 bg-white hover:shadow-lg"
                      }`}
                    >
                      <div className="aspect-[4/5] rounded-xl overflow-hidden bg-zinc-100 mb-3 relative">
                        <img
                          src={itemImg}
                          alt={item.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                        />
                        {isCurrent && (
                          <span className="absolute top-2 right-2 bg-[var(--primary-400)] text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow">
                            Viewing
                          </span>
                        )}
                      </div>
                      <h4 className="font-bold text-sm text-zinc-900 truncate group-hover:text-[var(--primary-400)] transition-colors">
                        {item.title}
                      </h4>
                      <p className="text-xs font-semibold text-zinc-500 mt-1">
                        INR {item.price || "N/A"}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>

      <dialog id="message_on_whatsapp" className="modal p-[15px]">
        <div className="modal-box max-w-[515px] !w-full !rounded-3xl border-none shadow-2xl">
          <h2 className="headings-h2 text-center text-zinc-900 mb-2">
            {t("product_details.whatsapp_btn")}
          </h2>
          <p className="body-md text-zinc-500 text-center mb-8">
            {t("product_details.whatsapp_subtitle")}
          </p>

          <div className="flex flex-col gap-6">
            <div className="form-group flex flex-col gap-2">
              <label className="text-sm font-bold text-zinc-500 uppercase tracking-wider">{t("product_details.select_quantity")}</label>
              <select
                className="form-control-custom !h-14 !rounded-xl !bg-zinc-50 !border-zinc-200"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
              >
                {[1, 2, 3, 4, 5, 10, 20].map(n => (
                  <option key={n} value={n}>{n}</option>
                ))}
              </select>
            </div>
            <div className="form-group flex flex-col gap-2">
              <label className="text-sm font-bold text-zinc-500 uppercase tracking-wider">{t("product_details.message")}</label>
              <textarea
                className="form-control-custom !h-[120px] !rounded-xl !bg-zinc-50 !border-zinc-200 p-4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={t("product_details.message_placeholder")}
              ></textarea>
            </div>
            <button
              className="btn btn-pri w-full overflow-hidden"
              onClick={handleSendMessage}
              disabled={sending || !message.trim()}
            >
              <div className="flex items-center justify-center gap-2 h-full w-full">
                <span className="font-bold leading-none">
                  {sending ? t("common.sending") : t("product_details.send_request")}
                </span>
              </div>
            </button>
            <button
              className="btn btn-ghost w-full !h-10 text-zinc-400 font-medium"
              onClick={() => document.getElementById("message_on_whatsapp").close()}
            >
              {t("product_details.close")}
            </button>
          </div>
        </div>
      </dialog>


      <dialog id="instructions" className="modal p-[15px]">
        <div className="modal-box max-w-[515px] !w-full">
          <h2 className="headings-h1 text-zinc-800 mb-3">Instructions</h2>
          <p className="body-sm text-zinc-500 !leading-[1.5]">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry.
          </p>
          <p className="body-sm text-zinc-500 !leading-[1.5]">
            Lorem Ipsum has been the industry's standard dummy text ever since
            the 1500s, when an unknown printer took a
          </p>
          <p className="body-sm text-zinc-500 !leading-[1.5]">
            galley of type and scrambled it to make a type specimen book. It has
            survived not only five centuries,
          </p>
          <p className="body-sm text-zinc-500 !leading-[1.5]">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown printer took a galley of type
          </p>
        </div>
        <form method="dialog">
          {/* if there is a button in form, it will close the modal */}
          <button className="bg-white subtitle-2 flex items-center gap-[5px] px-[15px] py-[10px] rounded-full">
            <img src="/images/close.svg" alt="close" />
            <span className="subtitle-2 bold">{t("product_details.close")}</span>
          </button>
        </form>
      </dialog>

      <ShareModal
        isOpen={showShareModal}
        onClose={() => setShowShareModal(false)}
        product={product}
      />

      {product && (
        <ShoplistSelectModal
          isOpen={isShoplistModalOpen}
          product={product}
          onClose={() => setIsShoplistModalOpen(false)}
          onSaved={handleShoplistSaved}
        />
      )}
    </>
  );
}

export default Details;
